<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-11-18 14:18:51
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2023-11-18 16:46:09
 * @FilePath: \xyjh-web\src\views\mobile\upload\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="main">
    <div class="upload">
      <van-uploader v-model="fileList" multiple />
    </div>
    <div class="button">
      <van-button type="default" size="large" @click="upload">上传</van-button>
    </div>
    <!-- 接码弹窗 -->
    <!-- <van-dialog v-model="show" title="" :show-confirm-button="false">
    </van-dialog> -->

    <van-popup
      v-model="showPanel"
      closeable
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="form">
        <van-form @submit="onSubmit">
          <van-field
            maxlength="11"
            v-model="form.tel"
            type="tel"
            label="手机号"
            placeholder="请输入手机号"
            :rules="[{ validator: checkPhone, message: '手机号码格式不正确' }]"
            @input="checkNum"
          />
          <van-field
            maxlength="4"
            v-model="form.code"
            label="短信验证码"
            placeholder="请输入短信验证码"
          >
            <template #button>
              <van-button
                v-if="showCode"
                :disabled="disabledSendCode"
                size="small"
                type="text"
                @click="sendVerificationCode"
                >发送验证码</van-button
              >
              <van-button
                v-if="!showCode"
                :disabled="true"
                size="small"
                type="text"
                >{{ count }}秒后重发</van-button
              >
            </template>
          </van-field>

          <div class="submit-button">
            <van-button round type="primary" native-type="submit"
              >提 交</van-button
            >
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  metaInfo: {
    title: "《群侠传》官方网站_Q版千年武侠手游_值得期待的江湖世界",
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年三,千年手游,千年官网,千年手游官网,武林群侠传,九妖,九妖官网,九妖手游,九妖手游官网,千年三官网,千年盛世,千年盛世手游,千年盛世官网,千年游戏盒子,Q版武侠,开放世界手游,巴雄天下,剑雨如歌,侠众道,异侠传,异侠传手游,金庸群侠传,剑网三手游,仙剑世界,千年游戏,千年盒子",
      },
    ],
  },
  watch: {
    checkPhone(val) {
      return val;
    },
  },
  data() {
    return {
      showPanel: true,
      showCode: true,
      disabledSendCode: true,
      count: "",
      timer: null,
      form: {
        tel: "",
        code: "",
      },
      url: "",
      fileList: [],
    };
  },
  created() {},
  methods: {
    ...mapActions({ getDownloadUrl: "base/getDownloadUrl" }),
    // 上传
    upload() {
      this.showPanel = true;
    },
    checkNum(e) {
      this.checkPhone(e);
    },
    cancel() {},
    confirm() {},
    // 提交
    onSubmit(values) {
      console.log("submit", values);
    },
    checkPhone(value) {
      var reg = /^1[3456789]\d{9}$/;
      let res = reg.test(value) ? true : false;
      this.disabledSendCode = !res;
      return res;
    },

    // 发送验证码
    sendVerificationCode() {
      let TIME_COUNT = 60;

      if (!this.timer) {
        this.count = TIME_COUNT;

        this.showCode = false;

        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;

            clearInterval(this.timer);

            this.timer = null;
          }
        }, 1000);

        // this.getCode();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-width: 750px;
  // height: calc(100vh - 56px);
  height: 100vh;
  background-color: #dad096;
  display: flex;
  flex-direction: column;
  align-items: center;
  // align-items: center;
  .upload {
    width: 300px;
    height: auto;
    padding: 30px 0;
    margin-top: 100px;
    margin-bottom: 100px;
    border: 2px dashed #fff;
    border-radius: 30px;
    /deep/ .van-uploader {
      display: flex;
      flex-wrap: wrap;
      // justify-content: center;
    }

    /deep/ .van-uploader__preview {
      width: 80px;
      height: 80px;
      margin: 10px;
    }

    /deep/ .van-uploader__upload {
      width: 80px;
      height: 80px;
      margin: 10px;
      // background-color: transparent;
      border-radius: 10px;
    }
  }

  .button {
    width: 300px;
  }

  .form {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 200px;
    margin-top: 50px;
    .submit-button {
      display: flex;
      justify-content: center;
      margin-top: 50px;
    }
  }
  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  @-webkit-keyframes tada {
    0% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
    10%,
    20% {
      -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -1deg);
      transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -1deg);
    }
    30%,
    50%,
    70%,
    90% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 1deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 1deg);
    }
    40%,
    60%,
    80% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -1deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -1deg);
    }
    100% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  @keyframes tada {
    0% {
      -webkit-transform: scale3d(1, 1, 1);
      -ms-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
    10%,
    20% {
      -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -1deg);
      -ms-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -1deg);
      transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -1deg);
    }
    30%,
    50%,
    70%,
    90% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 1deg);
      -ms-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 1deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 1deg);
    }
    40%,
    60%,
    80% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -1deg);
      -ms-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -1deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -1deg);
    }
    100% {
      -webkit-transform: scale3d(1, 1, 1);
      -ms-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  .download-button {
    -webkit-animation-name: tada;
    animation-name: tada;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    z-index: 998;
  }
}
</style>
